import type { FaireProductEntity } from "../../entity_types/product";

export const p_cusr8qy8ch: FaireProductEntity = {
  token: "p_cusr8qy8ch",
  type: "product",
  name: "Sunrise Blend Granola",
  brandName: "Aloha Sunrise Granola",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/66f6f493c5a81637a7c57e652e3aa803226286105e51c24f718d97c8b0cad1a9.png",
  priceDollars: 3.9,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b07bbc1be12daab20dd34f09bc8b4cc8fc53cc9d013df276cb2fcd830b9a6e99.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
